import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { API } from 'network/api';
import { useMemo } from 'react';
import { CommonListParams, DataPagination } from 'types/common';

type BankNameResponse = AxiosResponse<
  DataPagination<{
    id: string;
    name: string;
  }>
>;

type BankNameParams = CommonListParams;

const useBankNameList = (params?: BankNameParams) => {
  const queryParams = useMemo(
    () => ({
      size: params?.size ?? 100,
      'name.contains': params?.search,
      ...(params?.search && { 'name.contains': params?.search?.trim() }),
    }),
    [params],
  );

  const query = useQuery<BankNameResponse>({
    queryKey: ['bank-name', queryParams],
    queryFn: () =>
      API.get(
        '/collection/payment-type?isBank.equals=true&status.equals=Active',
        { params: queryParams },
      ),
  });

  const bankNameOptions = useMemo(() => {
    return query.data?.data?.content?.map((data) => ({
      value: data.id,
      label: data.name,
    }));
  }, [query.data]);

  return { ...query, bankNameOptions };
};

export default useBankNameList;
